import { useRef, useState } from "react";

export default function HelpFeedback({ sidebarTheme }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const isMobile = window.innerWidth <= 600;

  const isDark = sidebarTheme.bgMain === "#020617";

  return (
    <div
      ref={wrapperRef}
      style={{
        position: "relative",
        display: "block",
        width: "100%",
      }}
    >
      {/* BUTTON */}
      <div
        onClick={() => setOpen((v) => !v)} // ✅ CLICK TO TOGGLE
        style={{
          minHeight: 56,
          padding: "16px 14px",
          borderRadius: 14,
          fontSize: 17,
          fontWeight: 700,
          textAlign: "center",
          cursor: "pointer",

          background: isDark
            ? "linear-gradient(180deg, #0b1220, #020617)"
            : "#f1f5ff",

          border: `1px solid ${
            isDark ? "rgba(124,58,237,0.45)" : "rgba(124,58,237,0.35)"
          }`,

          color: isDark ? "#e5e7eb" : "#1e3a8a",

          boxShadow: isDark
            ? "inset 0 0 0 1px rgba(124,58,237,0.25)"
            : "0 4px 10px rgba(124,58,237,0.15)",

          transition: "all 0.2s ease",
        }}
      >
        🆘 Help & Feedback
      </div>

      {/* POPUP */}
      {open && (
        <div
          style={{
            position: isMobile ? "fixed" : "absolute",

            /* MOBILE → bottom sheet */
            left: isMobile ? 0 : "100%",
            right: isMobile ? 0 : "auto",
            bottom: isMobile ? 0 : "100%",

            width: isMobile ? "100%" : 420,
            maxWidth: "100vw",
            minHeight: isMobile ? "70vh" : 460,
            maxHeight: isMobile ? "85vh" : "auto",

            borderRadius: isMobile ? "20px 20px 0 0" : 20,
            padding: 20,

            background: sidebarTheme.card,
            color: sidebarTheme.text,
            border: `1px solid ${sidebarTheme.border}`,

            boxShadow: "0 -20px 50px rgba(0,0,0,0.35)",
            overflowY: "auto",
            zIndex: 100000,
          }}
        >
          {isMobile && (
            <div
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                top: 12,
                right: 16,
                fontSize: 22,
                cursor: "pointer",
                opacity: 0.7,
              }}
            >
              ✕
            </div>
          )}

          {/* HEADER */}
          <div style={{ display: "flex", gap: 14, marginBottom: 22 }}>
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: isDark ? "#7c3aed" : "#8b5cf6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 20,
              }}
            >
              🌐
            </div>

            <div>
              <div style={{ fontSize: 20, fontWeight: 800 }}>
                Support & Feedback
              </div>
              <div style={{ fontSize: 14, opacity: 0.7 }}>
                Get help or share your thoughts
              </div>
            </div>
          </div>

          {/* ACTIONS */}
          <ActionCard
            bg={isDark ? "#2a0f15" : "#fee2e2"}
            color={isDark ? "#fca5a5" : "#dc2626"}
            icon="📧"
            title="Technical Support"
            desc="Report bugs & technical issues"
            onClick={() =>
              window.open(
                "mailto:speeddigitstrainer@gmail.com?subject=Technical issues%20-%20SpeedDigits%20Trainer",
                "_blank"
              )
            }
          />

          <ActionCard
            bg={isDark ? "#0f2a1b" : "#dcfce7"}
            color={isDark ? "#86efac" : "#15803d"}
            icon="💬"
            title="Share Feedback"
            desc="Ideas, suggestions & improvements"
            onClick={() =>
              window.open(
                "mailto:speeddigitstrainer@gmail.com?subject=Feedback%20-%20SpeedDigits%20Trainer",
                "_blank"
              )
            }
          />

          <ActionCard
            bg={isDark ? "#1f1435" : "#f3e8ff"}
            color={isDark ? "#c4b5fd" : "#6d28d9"}
            icon="📝"
            title="Feedback & Bug Report Form"
            desc="Report bugs, errors or suggest improvements"
            onClick={() =>
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSe9-scHpmL1ikbefy4jeZRpRjKJnjVeyvalRQ77ffBOCeIs4Q/viewform",
                "_blank"
              )
            }
          />

          <ActionCard
            bg={isDark ? "#0f2030" : "#e0f2fe"}
            color={isDark ? "#7dd3fc" : "#0369a1"}
            icon="📢"
            title="Live Chat"
            desc="Quick assistance via Telegram"
            onClick={() =>
              window.open("https://t.me/speeddigitstrainer", "_blank")
            }
          />

          {/* FOOTER */}
          <div
            style={{
              marginTop: 26,
              padding: 16,
              borderRadius: 14,
              background: isDark ? "#2a1f05" : "#fef3c7",
              color: isDark ? "#fde68a" : "#92400e",
              fontSize: 14,
            }}
          >
            <strong>💡 We value your input!</strong>
            <div style={{ marginTop: 6, lineHeight: 1.6 }}>
              Report technical issues or share feedback to help us improve your
              experience.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- CARD ---------- */

function ActionCard({ bg, color, icon, title, desc, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: bg,
        color,
        padding: "18px 16px",
        borderRadius: 16,
        marginBottom: 14,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        transition: "box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.boxShadow = "0 0 0 1px rgba(124,58,237,0.45)")
      }
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
    >
      <div style={{ display: "flex", gap: 14 }}>
        <div style={{ fontSize: 24 }}>{icon}</div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 16 }}>{title}</div>
          <div style={{ fontSize: 14, opacity: 0.85 }}>{desc}</div>
        </div>
      </div>

      <div style={{ fontSize: 18, opacity: 0.8 }}>↗</div>
    </div>
  );
}
